import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import ReactLoading from 'react-loading'
import Arrow from 'mdi-react/ChevronRightIcon'
import SpotifyIcon from 'mdi-react/SpotifyIcon'

import renderField from 'Containers/Validation/renderField'
import validate from 'Containers/Validation/validate'
import { forgotPass } from 'Router/routes'
import { APP } from 'Configs/App'

const LogInForm = ({
  handleSubmit,
  isContinueButton,
  isRegularForm,
  loading,
  alreadyExistedEmail,
}) => {
  const { t } = useTranslation()

  return (
    <form className="form login-form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <div className="form__form-group-field">
            <Field
              component={renderField}
              name="email"
              placeholder={t('login.email')}
              type="email"
              data-cy="input-render-field-email"
              autoFocus
              defaultValue={alreadyExistedEmail && alreadyExistedEmail}
              onChange={e => localStorage.removeItem('alreadyExistedEmail')}
            />
          </div>
        </div>
      </div>
      {isRegularForm && (
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field
              component={renderField}
              name="password"
              placeholder={t('login.password')}
              type="password"
              data-cy="input-render-field-password"
            />
          </div>
          <div className="account__forgot-password">
            <Link to={forgotPass}>{t('login.forgot')}</Link>
          </div>
        </div>
      )}
      {isContinueButton && (
        <button
          className="btn btn-success account__btn account__btn--small"
          type="submit"
          data-cy="login-form-button-continue"
        >
          {loading ? (
            <ReactLoading className="loading" height={24} type="bars" />
          ) : (
            <>
              {t('login.continue')} <Arrow className="arrow-icon" />
            </>
          )}
        </button>
      )}
      {isRegularForm && (
        <button
          className="btn btn-success account__btn account__btn--small btn-login"
          type="submit"
          data-cy="login-form-button-submit"
        >
          {loading ? (
            <ReactLoading className="loading" height={24} type="bars" />
          ) : (
            <>
              {t('login.login')} <Arrow className="arrow-icon" />
            </>
          )}
        </button>
      )}
      {isRegularForm && (
        <>
          <div className="block__or">
            <p>{t('login.easilyUsing')}</p>
          </div>
          <a
            className="btn btn-spotify account__btn account__btn--small"
            data-cy="login-form-sign-in-with-spotify"
            href={APP.SPOTIFY_AUTH_API}
          >
            <SpotifyIcon />
            &nbsp;
            {t('login.signInWithSpotify')}
          </a>
        </>
      )}
    </form>
  )
}

export default compose(
  reduxForm({
    form: 'log_in_form',
    validate,
    enableReinitialize: true,
  })
)(LogInForm)
